import * as React from 'react'
import { Typography, Box, Grid, FormControlLabel, Checkbox, FormControl, RadioGroup, Radio } from '@mui/material'
import { Form } from 'react-bootstrap'
import { JobT } from '../../../../../types/Job'
import _ from 'lodash'
import { useMemoCompare } from '../../../../../utils/hooks'


interface EstimatesProps {
    addressState: string
    jobType: string | string
    value: string
    updateValue(value: string): void
}

const Estimates: React.FunctionComponent<EstimatesProps> = (props): JSX.Element => {
    let [estimate, setEstimate] = React.useState(null)
    const [currentValue, setCurrentValue] = React.useState(null);

    const valueFinal = useMemoCompare(props.value, (prev, next) => {
        return prev && (prev === next);
    });

    React.useEffect(() => {
        if (!_.isEqual(valueFinal, currentValue)) {
            setCurrentValue(valueFinal)
        }

    }, [valueFinal]);

    const coloradoEstimate = (): JSX.Element => {
        return (
            <div>

            </div>
        )
    }


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value
        setEstimate(value);
        props.updateValue(value)
    };


    const genericEstimate = (): JSX.Element => {
        return (
            <Box className="mt-2">
                <Typography variant="h4">Estimates</Typography>
                <Grid container spacing={3} >
                    <Grid item xs={12}>

                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="estimates"

                                name="controlled-estimates-radio-buttons-group"
                                value={currentValue}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    value="none"
                                    control={<Radio />}
                                    label={<Typography component="span">I did not request a written estimate on this shipment and understand <Typography component="span" fontWeight="bold">I will be required to pay charges on this contract</Typography></Typography>} />
                                <FormControlLabel
                                    value="binding"
                                    control={<Radio />}
                                    label={<Typography>I understand this shipment is moving under a binding estimate and that I will be required to pay the amount shown on that estimate.</Typography>}
                                />
                                <FormControlLabel
                                    value="nonbinding"
                                    control={<Radio />}
                                    label={<Typography>I understand this shipment is moving under a non-binding estimate.</Typography>}
                                />
                            </RadioGroup>
                        </FormControl>

                    </Grid>
                </Grid>
                <Typography>
                    <Typography component="strong" style={{ fontWeight: "bold" }} >NOTE:</Typography> If the charges shown on this bill exceed the charges in the non-binding estimate given to me by the
                    carrier, the carrier must release the shipment to me upon payment of no more than 125% of the estimated
                    charges and will extend credit for 30 days in which I must pay the remainder due. In no case will I be required
                    to pay more than 125% of the estimate (plus any supplemental estimates) for mileage rated shipments nor
                    more than 125% of the estimate (plus supplements) for hourly rated shipments (NOT INCLUDING PACKING).
                </Typography>
            </Box>
        )
    }
    console.log("render->BillOfLading->Estimates")
    switch (props.jobType) {
        case 'intrastate_local':
            switch (props.addressState) {
                case 'Colorado':
                    return coloradoEstimate()
                default:
                    return genericEstimate()
            }
        default:
            return genericEstimate()
    }
}

export default Estimates